import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'getRowIndex',
  standalone: true
})
export class GetRowIndexPipe implements PipeTransform {

  transform(item: any, itemsArray: any[]): number {
    return itemsArray.indexOf(item);
  }

}
